<fieldset class="fieldset-form">
  <legend>Complete Maintenance Schedule</legend>
  <table-adapter #maintScheduleTable [tableLabel]="'maintenance-schedule-table'"
    [columns]="columns" [canInteract]="IsClaimClosed ? CanEditClosedClaim : isAdjuster" (context)="removeMaintenance($event)" [canRenderActions]="canRenderActions"> </table-adapter>
</fieldset>